<template>
  <ul>
    <li v-for="(item, index) in categoryList" :key="`${item.categoryName}-${index}`" @click.stop="toggle(item, item.categoryIdList[0], item.categoryId, sessionTarget) & $send('vschool_courseclass_courseclassother_buttonclick', {'sessionTarget': sessionTarget, 'courseclass': item.categoryName, 'categoryId': item.categoryId})" :class="{'active': (!item.children || !item.children.length) && (item.isOpen)}">
      <div>
        <p :style="{'margin-left': 16 * item.layer + 'px'}">
          <a href="javascript:;">
            {{item.categoryName}}
          </a>
        </p>
        <i class="iconfont" :class="{'icon-rule-arrow-down': item.isOpen, 'icon-rule-arrow-up': !item.isOpen}" v-if="item.children && item.children.length"></i>
        <i class="arrow-icon" v-if="(!item.children || !item.children.length) && item.isOpen"></i>
      </div>
      <template v-if="item.children && item.children.length && item.isOpen">
        <tree v-model:categoryList="item.children" @toggle="toggle"></tree>
      </template>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'tree',
  props: {
    categoryList: {
      type: Object,
      default () {
        return {}
      }
    },
    menuCategory: {
      type: [String, Number]
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['sessionTarget'])
  },
  methods: {
    toggle (item, menuCategory, categoryId, target) {
      this.$emit('toggle', item, menuCategory, categoryId, target)
    }
  }
}
</script>

<style lang="scss" scoped>
li {
  float: left;
  width: 100%;
  cursor: pointer;
  background: #fff;
  min-height: 44px;
  padding: 0;
  line-height: 44px;
  border-radius: 5px;
  position: relative;
  margin:0 0;
  > div {
    border-radius: 5px;
    margin: 8px 0;
    position: relative;
  }
  &.active {
    > div {
      background: #f4f5f7;
      color: #333;
    }
  }
  a:hover {
    color: #FD3374;
    text-decoration: none;
  }
  .arrow-icon {
    position: absolute;
    right: 8px;
    top: 17px;
    width: 0;
    height: 0;
    font-size: 0;
    overflow: hidden;
    border-style: solid;
    border-color: transparent transparent transparent #656565;
    border-width: 5px;
  }
}
</style>
